// src/utils/EventFormatter.js - COMPLETELY NEW INTERNALS
export const formatEventsForCalendar = (events) => {
  if (!Array.isArray(events)) return [];
  
  return events.map(event => {
    // Simple conversion - no complex parsing!
    const startDate = new Date(event.scheduled_datetime);
    const endDate = new Date(startDate.getTime() + (event.duration_minutes * 60 * 1000));
    
    return {
      // Calendar required fields
      id: event.id,
      title: event.title,
      start: startDate,
      end: endDate,
      
      // Pass through all backend data
      ...event,
      
      // Styling for calendar
      backgroundColor: getEventColor(event.event_category, event.status),
      borderColor: getEventBorderColor(event.status),
      textColor: '#ffffff'
    };
  }).filter(event => !isNaN(event.start.getTime())); // Filter invalid dates
};

// Keep the color functions (they're still useful)
const getEventColor = (category, status) => {
  if (status === 'completed') return '#22c55e';
  if (status === 'cancelled') return '#ef4444';
  if (category === 'service') return '#3b82f6';
  return '#6b7280';
};

const getEventBorderColor = (status) => {
  if (status === 'confirmed') return '#059669';
  if (status === 'pending') return '#d97706';
  return 'transparent';
};